import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

export const verifyOtp = createAsyncThunk(
  'auth/verifyOtp',
  async ({ email, code, lang }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/auth/user/verify`,
        { email, code: Number(code) },
        {
          headers: {
            'Accept': 'application/json',
            'Accept-Language': lang || 'en',
            'Content-Type': 'application/json',
          },
        }
      );

      if (response?.data?.status === false) {
        return rejectWithValue(response?.data?.message || 'Verification failed');
      }

      return response.data;
    } catch (error) {
      const responseData = error.response?.data;
      const message = responseData?.message
        || responseData?.error
        || error.message
        || 'Verification failed';
      return rejectWithValue(message);
    }
  }
);
